
import { HASHTAGS } from "../../../type/EnumHashtags";
import { BRAND } from "../../../type/EnumBrand";
import { IProductData } from "../../../type/IProductData";

export const h47Fet: IProductData = {
  id: "heiserman-h47-fet",
  name: "Heiserman Audio H47 FET",
  description: "FET Condenser Microphone",
  specialOrder: true,
  images: ["/img/heisermanaudio_H47Fet.jpg", "/img/heisermanaudio_H47Fet_internal.jpg"],
  details: [{
    label: "Description",
    markdown: `
A modern nod to the classic U47 FET condenser microphone featuring a versatile, smooth, and detailed sound.  
Versatile, smooth, and detailed - the Heiserman H47 is a nod to the classic Neumann U47 FET condenser microphone, which was originally designed as a phantom powered version of the U47 tube mic.  
The H47 faithfully recreates the sound of the U47 FET, and excels in all of the same uses.  
Two years in the making, the H47 was developed alongside, and compared extensively to an original U47 FET.  
We think you'll be blown away by the sound of this mic, whether you're a new user or someone experienced with the original vintage mic.  

Thanks to its smooth, full response, and gentle presence boost, the H47 is well suited to be your main studio mic.  
Or, if you're looking for a dedicated mic for vocals or kick drum, the H47 is the perfect choice.  

Modern Design
Heiserman's 'no compromise' commitment to quality means getting the details right - they design and manufacture the H47 in the USA.  
As such, they have full control over every aspect of the mic's construction, from the capsule to the head basket, from the body to the final plating.  
They've bent over backwards to make sure that the H47 sounds incredible, looks stunning, and feels amazing in your hands.  
This is a premium mic, through and through.  

The Heart of the Microphone - The HK47 Capsule. 
Unlike most mic companies, Heiserman design, manufacture, and assemble their own capsules.  
By keeping everything in house, they have been able to extensively refine our capsules, while also ensuring the highest quality and consistency of manufacturing and assembly.  
With the latest version of the HK47, Heiserman have reached the pinnacle of this design - the ultimate balance of smooth, full, and present.  
In other words, it doesn't get any better than this!  

The Circuit
The H47 is true to the original circuit, and features 100% through-hole components, including modern, low noise FETs -- this mic is dead quiet!  
It also has high-quality Wima film caps and precision resistors, as well as polystyrene and tantalum caps (per the original schematic).  

And like the 47 FET, the H47 features two separate pad switches, one -10 dB, and one -6 dB.  
For many engineers, combining the two pads was the secret to capturing incredible kick drum tones.  
The additional pad is achieved via the inclusion of a custom Cinemag transformer. Of course, the H47 also includes a 200 Hz high pass filter switch.  
`
  }, {
    label: "Specifications",
    markdown: `
- Package Contents:	H47 microphone and Pelican case
- Tube or Solid State:	Solid State
- Capsule Type:	HK47
- Transducer Type:	Condenser
- Number of Microphones:	Single Microphone
- Analog or Digital:	Analog
    `
  }, {
    label: "Manufacturer Links",
    markdown: `
- <a to="https://heisermanaudio.com/products/h47" target="_blank">https://heisermanaudio.com/products/h47</a>
    `
  }],
  videos: ["https://www.youtube.com/embed/pAoa6fc5_DI?si=EdXPQhsQrKmz9z6V", "https://www.youtube.com/embed/REoTQa6D4s8?si=9X58yFPEPC5q8vCh"],
  metadata: {
    hashtags: [HASHTAGS.LIVE_SOUND, HASHTAGS.RECORDING, HASHTAGS.MICROPHONE],
    manufacturer: BRAND.HEISERMAN,
  }
}